export default __webpack_public_path__ + "static/media/ava1.f2288192.png";